<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :fullscreen="isMobile" :title="$t('common.personal_info')"
        @input="val => { if (!val) hide() }" @close="hide">
        <basic-info-stepper noTitle @change="basicInfoData" withFile ref="basicInfo" />

        <template v-slot:footer>
            <div class="footer-row">
                <v-btn depressed x-large class="footer-cancel" @click="hide">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn depressed x-large color="primary" class="footer-save black--text" :disabled="disabled"
                    @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import firebase, { db } from "@/utils/Firebase";
import BasicInfoStepper from '../entrance/elements/BasicInfoStepper.vue';
import BaseDialog from './BaseDialog.vue';

export default {
    name: "EditPersonalInfoDialog",
    components: { BasicInfoStepper, BaseDialog },
    data() {
        return {
            dialog: false,
            loading: false,
            name: '',
            phone: '',
            phoneCode: '',
            birthDate: '',
            gender: '',
            country: '',
            file: null,
            deletedImage: false,
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.name
        },
        hasStripeCustomer(vm = this) {
            return !!vm.account?.stripeAccount && ['coach', 'company'].includes(vm.account?.accountType)
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        updatePhoneStripe: firebase.functions().httpsCallable('httpPayments-updatePhoneStripe'),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            if (vm.$refs.basicInfo) vm.$refs.basicInfo.resetImg()
        },
        basicInfoData(payload) {
            const vm = this
            vm.name = payload.name || ''
            vm.birthDate = payload.birthDate || ''
            vm.country = payload.country || ''
            vm.phone = payload.phone || ''
            vm.phoneCode = payload.phoneCode || ''
            vm.gender = payload.gender || ''
            vm.file = payload.file || null
            vm.deletedImage = payload.deletedImage || false
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                let payload = {
                    name: vm.name,
                    phone: vm.phone,
                    phoneCode: vm.phoneCode,
                    birthDate: vm.birthDate,
                    gender: vm.gender,
                    country: vm.country,
                }

                if (vm.file) {
                    const img = await vm.$refs.basicInfo.uploadImg()
                    payload.logo = {
                        url: img?.tempUrl || '',
                        savePath: img?.savePath || '',
                    }
                } else if (vm.deletedImage) {
                    payload.logo = null
                }

                await db.collection('users').doc(vm.currentUser.uid).update(payload)

                if (vm.phone && vm.phone !== vm.account?.phone && vm.hasStripeCustomer) await vm.updatePhoneStripe()

                await vm.bindUserAccount(vm.currentUser)

                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        },
    },

}
</script>

<style scoped>
.footer-row {
    display: flex;
}

.footer-cancel {
    flex: 0 0 auto;
    border-radius: 0 !important;
    height: 52px !important;
    border-right: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base) !important;
    color: var(--v-txtSecondary-base) !important;
    font-weight: 500;
}

.footer-save {
    flex: 1 1 auto;
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>